var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.bannerDisplay && _vm.imageUrl)?_c('div',{staticClass:"bannerTop",style:('background-image: url(' + _vm.imageUrl +')')},[_c('div',{staticClass:"bannerTop-close"},[_c('i',{staticClass:"icon-banner-close",on:{"click":_vm.closeBanner}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }